import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useClaimForm } from '../context/ClaimFormContext'

// Keep the CookieFirst banner in the app language (its own switcher can persist a different one)
const syncCookieFirstLanguage = (lang) => {
  try {
    window.CookieFirst?.changeLanguage?.(lang)
  } catch {
    // banner not ready or language not configured in CookieFirst
  }
}

function I18nSync() {
  const { i18n } = useTranslation()
  const { data, updateField } = useClaimForm()
  const [, setLang] = useState(i18n.language)

  useEffect(() => {
    const handler = (lng) => {
      setLang(lng)
      const short = lng?.slice(0, 2)
      if (short) {
        document.documentElement.lang = short
        syncCookieFirstLanguage(short)
      }
      if (short && data.language !== short) {
        updateField('language', short)
      }
    }
    const handleCookieFirstInit = () => syncCookieFirstLanguage(i18n.language?.slice(0, 2))
    const initial = i18n.language?.slice(0, 2)
    if (initial) document.documentElement.lang = initial
    i18n.on('languageChanged', handler)
    window.addEventListener('cf_init', handleCookieFirstInit)
    return () => {
      i18n.off('languageChanged', handler)
      window.removeEventListener('cf_init', handleCookieFirstInit)
    }
  }, [i18n])

  useEffect(() => {
    if (data.language && i18n.language?.slice(0, 2) !== data.language) {
      i18n.changeLanguage(data.language)
    }
  }, [data.language])

  return null
}

export default I18nSync
